import * as yup from "yup";

// O yup.email() aceita "x@empresa" e "a..b@x.com", que o IsEmail do ms_aw recusa com 400.
const emailValido = yup
  .string()
  .email()
  .matches(/^[^\s@.]+(\.[^\s@.]+)*@[^\s@.]+(\.[^\s@.]+)*\.[a-z]{2,}$/i)
  .required();

export function emailInvalido(email: string) {
  return !emailValido.isValidSync(email);
}

export function adicionarEmails(atuais: string[], texto: string): string[] {
  const emails = [...atuais];

  for (const email of texto.split(/[\s,;]+/).filter(Boolean)) {
    if (!emails.some((atual) => atual.toLowerCase() === email.toLowerCase())) {
      emails.push(email);
    }
  }

  return emails;
}
